// extracted by mini-css-extract-plugin
export default {"bg_custom":"owner_profile_bg_custom__BpvSL","line":"owner_profile_line__RwtA6","dashboard":"owner_profile_dashboard__wkO-E","profiledata":"owner_profile_profiledata__w2rBR"};